export { SeparatorType as ListCellSeparatorType } from '@doordash/component-separator';

var ListCellSide;

(function (ListCellSide) {
  ListCellSide["Start"] = "START";
  ListCellSide["End"] = "END";
})(ListCellSide || (ListCellSide = {}));

var ListCellSize;

(function (ListCellSize) {
  ListCellSize["Small"] = "SMALL";
  ListCellSize["Large"] = "LARGE";
})(ListCellSize || (ListCellSize = {}));

export { ListCellSide, ListCellSize };
